import axios from "axios";
import { Client, IClient } from "@/shared/model/client.model";
import ParameterCompany from "@/shared/model/user-management/parameter-company.model";

const baseApiUrl = "api/parameters";

export default class ParameterService {
  public getListParametersForCompany(id: number): Promise<ParameterCompany[]> {
    let url = id != null ? "/company/" + id : "/company";
    return new Promise<ParameterCompany[]>(function (resolve, reject) {
      axios
        .get(baseApiUrl + url)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
  public getListParametersActivated(): Promise<ParameterCompany[]> {
    return new Promise<ParameterCompany[]>(function (resolve, reject) {
      axios
        .get(baseApiUrl + "/company/activated")
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public getListParameterModifiableByUser(): Promise<ParameterCompany[]> {
    return new Promise<ParameterCompany[]>(function (resolve, reject) {
      axios
        .get(baseApiUrl + "/company/director")
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public updateParameter(companyParam: ParameterCompany): Promise<ParameterCompany> {
    return new Promise<ParameterCompany>(function (resolve, reject) {
      axios
        .post(baseApiUrl + "/company", companyParam)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
